import { STATUS_LABELS } from '../constants';
import type { AssessmentStatus, VendorStatus } from '../types';

interface StatusLabelProps {
  status: AssessmentStatus | VendorStatus;
  count?: number;
}

const STATUS_COLORS: Record<AssessmentStatus | VendorStatus, string> = {
  needs_review: 'text-[#314158]',
  in_progress: 'text-[#314158]',
  reassessment_in_progress: 'text-[#314158]',
  input_needed: 'text-[#314158]',
  form_sent: 'text-[#314158]',
  complete: 'text-[#314158]',
  new_request: 'text-[#314158]',
};

export function StatusLabel({ status, count }: StatusLabelProps) {
  const label = STATUS_LABELS[status];
  const colorClass = STATUS_COLORS[status];

  // For aggregated display with count
  if (count !== undefined && count > 0) {
    return (
      <span className={`font-['Inter'] font-normal text-sm leading-5 ${colorClass}`}>
        {count} {label}
      </span>
    );
  }

  // For individual assessment status
  return (
    <span className={`font-['Inter'] font-normal text-sm leading-5 ${colorClass}`}>
      {label}
    </span>
  );
}
